<template>
  
  <div class="con_content">
       <div class="container">
            <div class="container_top h_48">App版本管理</div>
           

           
            <!-- table组件 -->
            <div class="my_table   my_body  padlr20">
               <Tabs type="card">
                    <TabPane label="Android">
                       
                        <ul class='my_ul'>
                            <li>
                                <div class='li_lft' >
                                    <span class="cRed"></span> 安卓版本 :
                                </div>
                                <div class='li_rgt' >
                                    <Input  ref='isFocuseA'      class='ipt'  placeholder="请输入文件版本"  v-model="and_model1"  clearable/>
                                </div>
                            </li>
                            <li>
                                <div class='li_lft' >
                                    <span class="cRed"></span>  apk下载链接 :
                                </div>
                                <div class='li_rgt' >
                                    <Input  ref='isFocuseA'     class='ipt'  placeholder="请输入文件链接"  v-model="and_model2"  clearable/>
                                </div>
                            </li>
                            <li>
                                <div class='li_lft' >
                                    <span class="cRed"></span>  文件大小 :
                                </div>
                                <div class='li_rgt' >
                                    <Input  ref='isFocuseA'    class='ipt'  placeholder="请输入文件大小"  v-model="and_model3"  clearable/>
                                </div>
                            </li>
                            <li>
                                <div class='li_lft' >
                                    <span class="cRed"></span>  是否强制更新 :
                                </div>
                                <div class='li_rgt' >
                                    <RadioGroup v-model="and_model4" class="lft top6" >
                                        <Radio label="1" class="mR20">是</Radio>
                                        <Radio label="0">否</Radio>
                                        
                                    </RadioGroup>
                                   
                                </div>
                            </li>
                            <li>
                                <div class='li_lft' >
                                    <span class="cRed"></span>  版本号 :
                                </div>
                                <div class='li_rgt' >
                                    <Input  ref='isFocuseA'    class='ipt'  placeholder="请输入文件版本号"  v-model="and_model5"  clearable/>
                                </div>
                            </li>
                            <li>
                                <div class='li_lft' >
                                    <span class="cRed"></span>  更新内容 :
                                </div>
                                <div class='li_rgt' >
                                    <Input v-model="and_model6" type="textarea" :rows="5" placeholder="请输入更新内容" />
                                </div>
                            </li>
                           
                            <li>
                                <div class='li_lft' >
                                    
                                </div>
                                <div class='li_rgt' >
                                    <Button type='warning' class="lft mR10" size='large' @click='load1'>取消</Button>
                                    <Button type='primary' class="lft" size='large' @click='route = "/layout/system/version/save";succ1();'>保存</Button>
                                </div>
                            </li>
                            
                        </ul>
                    </TabPane>
                    <TabPane label="IOS">
                        <ul class='my_ul'>
                            <li>
                                <div class='li_lft' >
                                    <span class="cRed"></span> IOS版本 :
                                </div>
                                <div class='li_rgt' >
                                    <Input  ref='isFocuseA'      class='ipt'  placeholder="请输入文件版本"  v-model="ios_model1"  clearable/>
                                </div>
                            </li>
                           
                            <li>
                                <div class='li_lft' >
                                    <span class="cRed"></span>  文件大小 :
                                </div>
                                <div class='li_rgt' >
                                    <Input  ref='isFocuseA'      class='ipt'  placeholder="请输入文件大小"  v-model="ios_model2"  clearable/>
                                </div>
                            </li>
                            
                            
                            <li>
                                <div class='li_lft' >
                                    <span class="cRed"></span>  更新内容 :
                                </div>
                                <div class='li_rgt' >
                                    <Input v-model="ios_model3" type="textarea" :rows="5" placeholder="请输入更新内容" />
                                </div>
                            </li>
                           
                            <li>
                                <div class='li_lft' >
                                    
                                </div>
                                <div class='li_rgt' >
                                    <Button type='warning' class="lft mR10" size='large' @click='load2'>取消</Button>
                                    <Button type='primary' class="lft" size='large' @click='route = "/layout/system/version/save";succ2();'>保存</Button>
                                </div>
                            </li>
                            
                        </ul>
                    </TabPane>
                    
                </Tabs>
            </div>

        </div>
        
    </div>
</template>

<script>
    import { mapState,mapMutations,mapGetters } from 'vuex';
    import { format } from 'path';
    
    export default {
        
        name:'version',
        data () {
            return {
                route: '',
                token:'',  
                list1: [],
                list2: [],

                and_model0: '',  //版本guid，提交时用
                and_model1:'',
                and_model2:'',
                and_model3:'',
                and_model4: '0',
                and_model5:'',
                and_model6:'',

                ios_model0: '',
                ios_model1: '',
                ios_model2: '',
                ios_model3: '',
            }    
        },
       
        
        
       
        methods: {
           load1(){
               let that = this;
               
                that.$ajax({
                
                    method:'get',
                    url: 'admin/service/app/version?platform=0',
                    data: {},
                   
                }).then(res => {
                       
                        that.list1 = res.data.data;
                        let list1 = res.data.data;
                        

                        that.and_model0 = list1.guid;

                        that.and_model1 = list1.versionName;
                        that.and_model2 = list1.url;
                        that.and_model3 = list1.size;
                        that.and_model4 = list1.update.toString();
                        that.and_model5 = list1.versionCode;
                        that.and_model6 = list1.content;

                       
                  
                }).catch(err=>{
                    console.log(err)
                });
               
             
           },
           succ1(){
                let that = this;
               
                that.$ajax({
                
                    method:'put',
                    url: 'admin/service/app/version?route='+that.route,
                    data: {
                        platform: 0,
                        guid:that.and_model0,
                        versionName:that.and_model1,
                        url:that.and_model2,
                        size: that.and_model3,
                        update:parseInt(that.and_model4),
                        versionCode: that.and_model5,
                        content:that.and_model6,
                    },
                    
                }).then(res => {
                      this.$alert.info(res)
                 
                  
                }).catch(err=>{
                    console.log(err)
                });
           },
           load2(){
               let that = this;
               
                that.$ajax({
                
                    method:'get',
                    url: 'admin/service/app/version?platform=1',
                    data: {},
                    
                }).then(res => {
                       
                        that.list2 = res.data.data;
                        let list2 = res.data.data;
                        that.ios_model0 = list2.guid;
                        that.ios_model1 = list2.versionName;
                        that.ios_model2 = list2.size;
                        that.ios_model3 = list2.content;
                        

                       
                  
                }).catch(err=>{
                    console.log(err)
                });
               
             
           },
           succ2(){
                let that = this;
               
                that.$ajax({
                
                    method:'put',
                    url: 'admin/service/app/version?route='+that.route,
                    data: {
                        guid: that.ios_model0,
                        platform: 1,
                        versionName:that.ios_model1,                      
                        size: that.ios_model2,                      
                        content:that.ios_model3,
                    },
                    
                }).then(res => {
                    this.$alert.info(res)
                }).catch(err=>{
                    console.log(err)
                });
           }
            
           
            
        },
        mounted: function(){
           var that = this;
           that.token = that.$store.state.token;
           that.guid = that.$store.state.guid;
           that.load1();
           that.load2();
           
            
        }
    }
</script>
<style scoped>
@import "/css/li_input.css"   
  
    
</style>




